import axios from 'axios';

function postRequest(url, payload, params = {}) {
  let options = {};
  if (params.headers) {
    options = { ...params.headers };
  }
  return axios.post(url, payload, options)
    .then(({ data }) => data);
}

function getRequest(url, payload, params = {}) {
  return axios.get(url, {
    params: payload,
    ...params,
  })
    .then(({ data }) => data);
}

export default {
  post: postRequest,
  get: getRequest,
};



// WEBPACK FOOTER //
// ./src/assets/js/http/request.js